import Vue from 'vue';
import * as _ from 'lodash';
import CommonErrorHandler from '@/helpers/CommonErrorHandler';
import { ApolloClient, ApolloError } from 'apollo-client';
import Router from 'vue-router';
import { GraphQLError } from 'graphql';

const errorHandler = new CommonErrorHandler();

export default async function processGraphQlError(
  e: ApolloError,
  store: any,
  client: ApolloClient<any>,
  router: Router,
) {
  const strippedMsg = errorHandler.cleanUpErrorMsg(e.message);
  try {
    // Error handler for checking user using an old session before the user account deleted
    // @ts-ignore
    if (e.networkError?.result?.code === 'UNAUTHORIZED_USER') {
      if (store.state.user.currentUser.id != undefined) {
        await store.dispatch('signOut');
        client.stop();
        await client.clearStore();
      }
      router.push('Welcome');
    } if (strippedMsg.toLowerCase().indexOf('unauthorized') !== -1) {
      if (store.state.user.currentUser.id != undefined) {
        await store.dispatch('signOut');
        client.stop();
        await client.clearStore();
      }
      router.push('Welcome');
    } else if (strippedMsg.indexOf('Cannot obtain building data') !== -1) {
      if (store.state.user.currentBuildingId != undefined) {
        await store.dispatch('dropCurrentBuilding');
        client.stop();
        await client.clearStore();
      }
      router.push('BuildingList');
    } else if (strippedMsg.indexOf('Floor not found') !== -1) {
      if (store.state.user.currentFloorId != undefined) {
        await store.dispatch('dropCurrentBuilding');
        client.stop();
        await client.clearStore();
      }
      router.push('BuildingList');
    }
  } catch (e) {
  }
}

export function getHumanReadableError(
  error: ApolloError,
  defaultErrorMessage: string = '',
): string {
  return _.first(getHumanReadableErrors(error)) || defaultErrorMessage;
}

export function getHumanReadableErrors(
  error: ApolloError
): (string | undefined)[] {
  const graphQLErrors = error.graphQLErrors;
  if (_.isEmpty(graphQLErrors)) {
    return [];
  }

  return _.map(graphQLErrors, translateGraphQLError);
}

export function translateGraphQLError(
  graphQLError: GraphQLError
): string | undefined {
  const errorCode = _.get(graphQLError, 'extensions.code');
  const properties = _.omit(
    _.get(graphQLError, 'extensions.exception', {}),
    ['stacktrace'],
  );

  switch (errorCode) {
    case 'ERROR_DUPLICATE_INVITATION':
      return Vue.i18n.translate('Error_Duplicate_Invitation');
    case 'ERROR_MEMBER_ALREADY_INVITED_AND_JOINED':
      return Vue.i18n.translate('Error_Member_Already_Invited_And_Joined');
    case 'ERROR_RESEND_INVITATION_TOO_FREQUENT':
      return Vue.i18n.translate('Error_Resend_Invitation_Too_Frequent');
    default:
      return undefined;
  }
}
